export default __webpack_public_path__ + "static/media/Red Check.9f2c9f5c.svg";